import {
    faPaperclip,
    faSave,
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createRef, useCallback, useEffect, useState } from "react";
import { ListarTipoDocumentoController } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoDocumento/TipoDocumentoController";
import { TipoDocumentoInterface } from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoDocumento/TipoDocumentoInterface";

interface IFile extends File {
    ID_TIPO_DOCUMENTO?: number;
}

interface IAnexarDocumentoProps {
    UM_POR_VEZ?: boolean;
    handleSubmit: (files: Array<IFile>) => Promise<void>;
}

export default function AnexarDocumento(props: IAnexarDocumentoProps) {
    const [LstDocs, setLstDocs] = useState<Array<IFile>>([]);
    const [LsTipoDocumento, setLsTipoDocumento] =
        useState<Array<TipoDocumentoInterface>>();
    const [requiredMissing, setRequiredMissing] = useState<Array<boolean>>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const inputRef = createRef<HTMLInputElement>();

    const handleDocsSubmit = useCallback(() => {
        setLoading(true);
        if (LstDocs && LstDocs.length) {
            let valido = true;
            setRequiredMissing(
                LstDocs.map((doc) => {
                    valido = valido && !!doc.ID_TIPO_DOCUMENTO;
                    return !doc.ID_TIPO_DOCUMENTO;
                })
            );

            if (valido) {
                props.handleSubmit(LstDocs)
                    .then(() => {
                        setLstDocs([]);
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            } else {
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    }, [props, LstDocs]);

    useEffect(() => {
        ListarTipoDocumentoController().then((res) => {
            setLsTipoDocumento(res);
        });
    }, []);

    return (
        <div className="w-100">
            <div className="pl-3 d-flex justify-content-between align-items-center">
                <h6>Anexar Documento ao Atendimento:</h6>
                <div>
                    {(!LstDocs.length || !props.UM_POR_VEZ) && (
                        <label htmlFor="file_input_anexo">
                            <span className="btn btn-clean btn-icon btn-md ml-2 mr-2">
                                <FontAwesomeIcon icon={faPaperclip} size="lg" />
                            </span>
                        </label>
                    )}
                    {!!LstDocs.length && (
                        <button
                            className="btn btn-clean btn-success btn-icon btn-md ml-2 mr-2"
                            onClick={() => {
                                handleDocsSubmit();
                            }}
                            disabled={loading}
                        >
                            <FontAwesomeIcon icon={faSave} size="lg" />
                        </button>
                    )}
                </div>
            </div>

            <div>
                <input
                    type="file"
                    multiple={!props.UM_POR_VEZ}
                    id="file_input_anexo"
                    ref={inputRef}
                    className="d-none"
                    onChange={(e) => {
                        const docs: Array<IFile> = Array.from(LstDocs || []);
                        for (
                            let index = 0;
                            index < (e.target.files?.length || 0);
                            index++
                        ) {
                            const element = e.target.files?.item(index);
                            if (
                                element &&
                                !LstDocs.some(
                                    (doc) => doc.name === element.name
                                )
                            )
                                docs.push(element);
                        }
                        setLstDocs(docs);
                    }}
                />

                {LstDocs && LstDocs.length > 0 ? (
                    LstDocs.map((arquivo, index) => {
                        return (
                            <div
                                className="d-flex flex-wrap justify-content-between"
                                key={arquivo.name}
                            >
                                <div
                                    className="btn btn-clean col-12 col-lg-6 d-flex justify-content-between mb-1"
                                    onClick={() => {
                                        setLstDocs(
                                            LstDocs.filter(
                                                (doc) =>
                                                    doc.name !== arquivo.name
                                            )
                                        );
                                    }}
                                >
                                    {arquivo.name.length > 20
                                        ? arquivo.name.substr(0, 20) + "..."
                                        : arquivo.name}
                                    <FontAwesomeIcon
                                        icon={faTimes}
                                        className="text-danger ml-2"
                                    />
                                </div>

                                <div className="col-12 col-lg-6">
                                    <select
                                        name="ID_TIPO_DOCUMENTO"
                                        className={`form-control placeholder-dark-50 ${
                                            requiredMissing[index]
                                                ? "is-invalid"
                                                : ""
                                        }`}
                                        onChange={(e) => {
                                            const docs = Array.from(
                                                LstDocs || []
                                            );
                                            docs[index].ID_TIPO_DOCUMENTO =
                                                Number.parseInt(e.target.value);

                                            setLstDocs(docs);

                                            if (e.target.value) {
                                                const required =
                                                    Array.from(requiredMissing);
                                                required[index] = false;
                                                setRequiredMissing(required);
                                            }
                                        }}
                                    >
                                        <option value={0}>
                                            Selecione tipo documento
                                        </option>
                                        {LsTipoDocumento?.length ? (
                                            LsTipoDocumento.map((TipoDoc) => {
                                                return (
                                                    <option
                                                        key={
                                                            TipoDoc.ID_TIPO_DOCUMENTO
                                                        }
                                                        value={
                                                            TipoDoc.ID_TIPO_DOCUMENTO
                                                        }
                                                    >
                                                        {
                                                            TipoDoc.DS_TIPO_DOCUMENTO
                                                        }
                                                    </option>
                                                );
                                            })
                                        ) : (
                                            <option></option>
                                        )}
                                    </select>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div></div>
                )}
            </div>
        </div>
    );
}
